export enum AlertType {
  LIGHT = 'LIGHT',

  MEDIUM = 'MEDIUM',

  SERIOUS = 'SERIOUS',

  CRITICAL = 'CRITICAL',
}
